import React, { Component } from 'react';
import { Map, GoogleApiWrapper, InfoWindow, Marker} from 'google-maps-react';

const mapStyles = {
  width: '100%',
  height: '100%'



};

export class MapContainer extends Component {

  state = {
    showingInfoWindow: false,  // Hides or shows the InfoWindow
    activeMarker: {},          // Shows the active marker upon click
    selectedPlace: {}          // Shows the InfoWindow to the selected place upon a marker
  };

  onMarkerClick = (props, marker, e) =>
  this.setState({
    selectedPlace: props,
    activeMarker: marker,
    showingInfoWindow: true
  });

onClose = props => {
  if (this.state.showingInfoWindow) {
    this.setState({
      showingInfoWindow: false,
      activeMarker: null
    });
  }
};

  render() {
    return (
    <div className="test">
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <br></br>

      <Map
        google={this.props.google} 
        zoom={15}
        style={mapStyles}
        initialCenter={
          {
            lat: 48.94431,
            lng: 2.32684
          }
        }
      >
              <Marker
          onClick={this.onMarkerClick}
          name={'Cabinet à domicile'}
        />
        <InfoWindow
          marker={this.state.activeMarker}
          visible={this.state.showingInfoWindow}
          onClose={this.onClose}
        >
          <div>
            <h4>{this.state.selectedPlace.name}</h4>
          </div>
        </InfoWindow>
      </Map>
      </div>
    );
  }
}
export default GoogleApiWrapper({
       apiKey: ('AIzaSyC4ygJOVMfa39tPV_OJeBxn87ZEKOPVM5Q')
})(MapContainer)